import React from "react";
import Header from "../header/Header";
import { Footer } from "../footer/Footer";
import styles from "../landingPageLayout/landingpage.module.scss";

interface IProps {
  children: string | JSX.Element;
}

const LandingPageLayout = ({ children }: IProps) => {
  return (
    <>
      <div className={styles.head}>
        <div className={styles.header_one}>
          <Header />
        </div>
        {children}
        <Footer />
      </div>
    </>
  );
};

export default LandingPageLayout;
